export const limboStyles = {
  container: {
    py: 4,
  },
  header: {
    mb: 1,
    width: '870px',
    maxWidth: '100%',
    height: '27px',
    textAlign: { xs: 'center', md: 'left' },
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontStyle: 'normal',
    fontSize: '24px',
    lineHeight: '36px',
    letterSpacing: '0.07px',
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    mt: 4,
  },
  card: {
    p: '1px',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    bgcolor: '#FFFFFF',
    boxShadow: '0px 1px 2px -1px rgba(0, 0, 0, 0.10), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)',
  },
  cardBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
  },
  filtersRow: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: { xs: 1.5, md: '16px' },
  },
  metricsRow: {
    width: '870px',
    height: '40px',
    display: 'flex',
    gap: '16px',
    maxWidth: '100%',
    mb: 2,
  },
  metricsBoxBase: {
    width: '181.9609375px',
    height: '40px',
    borderRadius: '10px',
    pt: '12.5px',
    pb: '12.5px',
    px: '16px',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
  },
  metricsBoxBlue: {
    bgcolor: '#E0E7FF',
  },
  metricsBoxGreen: {
    bgcolor: '#DCFCE7',
  },
  searchBlock: {
    width: '1388px',
    maxWidth: '100%',
    height: 'auto',
    mb: 2,
    py: { xs: 1, md: 0 },
  },
  searchArea: {
    width: '1388px',
    maxWidth: '100%',
    height: 36,
    // Keep TextFields tight like the spec
    bgcolor: '#FFFFFF',
    borderRadius: '10px',
    boxShadow: '0px 1px 2px -1px rgba(0, 0, 0, 0.10), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)',
    '& .MuiInputBase-root': {
      height: 36,
    },
  },
  searchNameArea: {
    width: { xs: '100%', md: '1096px' },
    height: 36,
    bgcolor: '#FFFFFF',
    borderRadius: '10px',
    border: '1px solid #E5E7EB',
    boxShadow: '0px 1px 2px -1px rgba(0, 0, 0, 0.10), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)',
    pt: '4px',
    pr: '4px',
    pb: '4px',
    pl: '4px',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
  },
  searchTimeArea: {
    width: { xs: '100%', md: '276px' },
    height: 36,
    bgcolor: '#FFFFFF',
    borderRadius: '10px',
    border: '1px solid #E5E7EB',
    pt: '4px',
    pr: '4px',
    pb: '4px',
    pl: '4px',
    boxSizing: 'border-box',
    boxShadow: '0px 1px 2px -1px rgba(0, 0, 0, 0.10), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)',
    display: 'flex',
    alignItems: 'center',
    overflow: 'visible',
  },
  searchTextField: {
    '& .MuiInputBase-root': {
      height: 36,
    },
    '& input': {
      fontFamily: 'Inter, sans-serif',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '14px',
      lineHeight: '100%',
      letterSpacing: '-0.15px',
    },
    '& .MuiOutlinedInput-root': {
      height: 36,
      borderRadius: 0,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 0,
    },
  },
  tableContainer: {
    boxShadow: 'none',
    maxHeight: 812,
    overflowY: 'auto',
    backgroundColor: '#FFFFFF',
  },
  table: {
    // Remove borders/separators for body cells.
    // Keep header/title dividers controlled by `tableTitleCell` / `tableHeadCell`.
    '& tbody .MuiTableCell-root': {
      border: 'none',
      borderTop: 'none',
      borderBottom: 'none',
      borderLeft: 'none',
      borderRight: 'none',
    },
    '& tbody th, & tbody td': {
      border: 'none',
      borderTop: 'none',
      borderBottom: 'none',
      borderLeft: 'none',
      borderRight: 'none',
    },
  },
  tableTitleCell: {
    bgcolor: '#FFFFFF',
    fontWeight: 600,
    width: '1386px',
    maxWidth: '100%',
    height: '57px',
    p: 0,
    px: '24px',
    pt: '16px',
    pb: '1px',
    //verticalAlign: 'top',
    borderBottom: '1px solid #F5F5F5',
    textTransform: 'none',
  },
  tableTitleText: {
    width: '165px',
    height: '24px',
    position: 'relative',
    top: '-0.5px',
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.31px',
    color: '#111827',
    opacity: 1,
    textTransform: 'none',
  },
  tableHeadCell: {
    color: '#9CA3AF', // light gray
    fontWeight: 600,
    fontSize: '0.75rem',
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
    borderBottom: 'none',
    py: 1.25,
    px: 1.5,
  },
  tableCell: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '21px',
    letterSpacing: '-0.15px',
    borderBottom: 'none',
    py: 1.25,
    px: 1.5,
  },
  restockButton: {
    width: '101.15625px',
    height: 36,
    borderRadius: '10px',
    backgroundColor: '#101828',
    color: '#FFFFFF',
    minWidth: 'unset',
    boxShadow: 'none',
    textTransform: 'none',
  },
  subheader: {
    mt: 0.5,
    width: '870px',
    maxWidth: '100%',
    bgcolor: '#F5F5F5',
    color: '#6B7280',
    height: 29,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    px: 0,
    mb: 2,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '21px',
    letterSpacing: '-0.15px',
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    mt: 1,
  },
  restockDialogPaper: {
    width: 512,
    height: 'auto',
    borderRadius: '10px',
    borderWidth: 1,
    bgcolor: '#FFFFFF',
    boxShadow: '0px 4px 6px -4px rgba(0, 0, 0, 0.10), 0px 10px 15px -3px rgba(0, 0, 0, 0.10)',
    borderTop: '1px solid rgba(0, 0, 0, 0.10)',
  },
  restockDialogContent: {
    p: '24px 25px 0',
    position: 'relative',
    width: '100%',
    height: 'auto',
  },
  restockDialogTitle: {
    width: '100%',
    height: 18,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontStyle: 'normal',
    fontSize: '18px',
    lineHeight: '18px',
    letterSpacing: '-0.44px',
    color: '#0A0A0A',
  },
  restockDialogClose: {
    position: 'absolute',
    top: 16,
    right: 16,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  restockOptionsBox: {
    width: '100%',
    height: 'auto',
    pt: '16px',
    pb: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: 2, // 16px
  },
  restockOptionCard: {
    width: 462,
    height: 64,
    pt: '12px',
    px: '12px',
    borderRadius: '10px',
    bgcolor: '#F3F4F6',
    boxSizing: 'border-box',
  },
  restockingLabel: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '21px',
    letterSpacing: '-0.15px',
    color: '#6B7280',
  },
  restockItemName: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '21px',
    letterSpacing: '-0.15px',
    color: '#111827',
  },
  restockItemId: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '12px',
    lineHeight: '18px',
    letterSpacing: '0px',
    color: '#6B7280',
    pb: '6px',
  },
  restockFieldHeader: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '-0.15px',
    color: '#0A0A0A',
  },
  restockFieldBox: {
    width: 462,
    height: 44,
    pr: '12px',
    pl: '12px',
    borderRadius: '8px',
    bgcolor: '#F3F3F5',
    boxSizing: 'border-box',
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: 'none',
    display: 'flex',
    alignItems: 'center',
  },
  restockNotesBox: {
    width: 462,
    height: 80,
    pr: '12px',
    pl: '12px',
    borderRadius: '8px',
    bgcolor: '#F3F3F5',
    boxSizing: 'border-box',
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: 'none',
    display: 'flex',
    alignItems: 'center',
  },
  /** Text button under Slot field — matches restock typography, not Add Item primary blue */
  restockNewSlotLink: {
    textTransform: 'none',
    p: 0,
    minWidth: 0,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '21px',
    letterSpacing: '-0.15px',
    color: '#101828',
    justifyContent: 'flex-start',
    '&:hover': {
      bgcolor: 'transparent',
      textDecoration: 'underline',
    },
    '&.Mui-disabled': {
      color: '#9CA3AF',
    },
  },
  restockInput: {
    width: '100%',
    '& .MuiInputBase-root': {
      height: '100%',
      padding: 0,
      margin: 0,
    },
    '& input, & select': {
      height: '100%',
      padding: 0,
      margin: 0,
      fontFamily: 'Inter, sans-serif',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '14px',
      lineHeight: '100%',
      letterSpacing: '-0.15px',
      color: '#717182',
    },
    '& input::placeholder': {
      color: '#717182',
      opacity: 1,
    },
  },
} as const;
